module.exports = __webpack_public_path__ + "img/ingenieur-forestier.ef412a82.jpg";